import * as React from "react"
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group"

import { cn } from "@/lib/utils"

// A row of pressable segments. `type="single"` behaves as a radio set,
// `type="multiple"` as a checkbox set; Radix owns the pressed state, ARIA and
// arrow-key roving focus.
function ToggleGroup({ className, ...props }) {
  return (
    <ToggleGroupPrimitive.Root
      data-slot="toggle-group"
      className={cn("flex flex-wrap items-center gap-[6px]", className)}
      {...props}
    />
  )
}

function ToggleGroupItem({ className, ...props }) {
  return (
    <ToggleGroupPrimitive.Item
      data-slot="toggle-group-item"
      className={cn(
        "rounded-[8px] border border-transparent bg-secondary px-[12px] py-[7px] text-[12.5px] font-semibold whitespace-nowrap text-muted-foreground transition-colors outline-none hover:border-line-2 hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:border-foreground data-[state=on]:bg-foreground data-[state=on]:text-background",
        className
      )}
      {...props}
    />
  )
}

export { ToggleGroup, ToggleGroupItem }
